(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[1471,1151,46,75],[1237,1151,116,52],[511,1082,353,52],[511,1190,164,52],[1142,1082,265,52],[841,1190,123,52],[677,1190,162,52],[866,1082,274,52],[760,1136,243,52],[1005,1151,230,52],[511,1136,247,52],[1355,1151,114,52],[1409,1082,199,67],[0,1082,509,508],[0,0,1920,1080]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_13 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_12 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_11 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_10 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_9 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_8 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_7 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_6 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_2 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.Image = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.image_02 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.zoom_white = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_white, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.zoom_brack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#000000").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#000000").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#000000").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_brack, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,540.0009,1,1.08);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.shadow = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.image_02();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.shadow, new cjs.Rectangle(0,0,1920,1080), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,1,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#DEC293").setStrokeStyle(2,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-1,-1,1922,2), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#B4B0BF").beginStroke().moveTo(27.8,16.9).curveTo(26.6,16.9,25.2,16.5).curveTo(23.8,16,22.6,15.1).curveTo(21.5,14.2,20.6,12.6).curveTo(19.9,11.1,19.8,8.9).lineTo(19.8,-16.9).lineTo(25.6,-16.9).lineTo(25.6,8.9).curveTo(25.5,10,26.2,10.5).curveTo(26.9,11.2,27.8,11.2).lineTo(30.4,11.2).lineTo(30.4,16.9).closePath().moveTo(13.8,16.9).curveTo(12.6,16.9,11.2,16.5).curveTo(9.8,16,8.6,15.1).curveTo(7.3,14.2,6.6,12.6).curveTo(5.8,11.1,5.8,8.9).lineTo(5.8,-16.9).lineTo(11.4,-16.9).lineTo(11.4,8.9).curveTo(11.5,10,12.1,10.5).curveTo(12.8,11.2,13.8,11.2).lineTo(16.3,11.2).lineTo(16.3,16.9).closePath().moveTo(-4,16.9).lineTo(-14.8,-6.6).lineTo(-14.9,-6.7).lineTo(-14.9,-6.6).lineTo(-23.1,11.2).lineTo(-15.5,11.2).lineTo(-12.9,16.9).lineTo(-27.6,16.9).curveTo(-28.8,16.9,-29.6,16).curveTo(-30.4,15.3,-30.4,14).curveTo(-30.4,13.6,-30.2,13.2).lineTo(-22.4,-4.1).lineTo(-22.3,-4.2).lineTo(-22.2,-4.4).lineTo(-20.7,-7.7).lineTo(-16.9,-15.9).lineTo(-16.6,-16.3).curveTo(-16,-16.8,-15,-16.9).lineTo(-14.8,-16.9).curveTo(-13.8,-16.8,-13.2,-16.3).lineTo(-12.8,-15.7).lineTo(-9.1,-7.7).lineTo(-7.6,-4.4).lineTo(-7.5,-4.3).lineTo(-7.5,-4.1).lineTo(0.9,14).lineTo(1,14.2).lineTo(1.3,14.7).lineTo(1.5,15.3).lineTo(2.3,16.9).closePath();
	this.shape.setTransform(97.1163,37.3007,0.7275,0.7273);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#9881D1").beginStroke().moveTo(11.6,20.6).lineTo(11.6,-2.6).curveTo(11.6,-4.1,12,-5.2).curveTo(12.3,-6.4,13,-7.3).curveTo(13.6,-8.2,14.4,-8.8).curveTo(15.2,-9.4,16.2,-9.8).curveTo(17,-10.2,18,-10.4).curveTo(18.8,-10.6,19.6,-10.6).lineTo(29.9,-10.6).curveTo(31.4,-10.6,32.6,-10.2).curveTo(33.7,-9.8,34.6,-9.2).curveTo(35.5,-8.6,36.2,-7.8).curveTo(36.8,-7,37.2,-6.1).curveTo(37.5,-5.2,37.8,-4.3).lineTo(37.9,-2.6).lineTo(37.9,5.2).curveTo(37.9,6.6,37.5,7.8).curveTo(37.2,9,36.5,9.9).curveTo(35.9,10.8,35.2,11.4).curveTo(34.3,12,33.5,12.4).curveTo(32.5,12.8,31.7,13).curveTo(30.7,13.2,29.9,13.2).lineTo(19.6,13.2).lineTo(19.6,7.5).lineTo(29.9,7.5).curveTo(31,7.5,31.7,6.9).curveTo(32.2,6.3,32.2,5.2).lineTo(32.2,-2.5).curveTo(32.2,-3.7,31.7,-4.3).curveTo(31,-4.9,29.9,-4.9).lineTo(19.6,-4.9).curveTo(18.5,-4.9,17.9,-4.3).curveTo(17.3,-3.7,17.3,-2.6).lineTo(17.3,20.6).closePath().moveTo(-11.3,13.2).curveTo(-12.5,13.2,-13.9,12.8).curveTo(-15.2,12.3,-16.4,11.4).curveTo(-17.6,10.5,-18.4,9).curveTo(-19.2,7.5,-19.2,5.3).curveTo(-19.2,4.1,-18.7,2.7).curveTo(-18.4,1.4,-17.4,0.2).curveTo(-16.5,-1,-15,-1.8).curveTo(-13.5,-2.6,-11.3,-2.6).lineTo(-1,-2.6).lineTo(-1,2.9).lineTo(-11.3,2.9).curveTo(-12.5,2.9,-13.1,3.6).curveTo(-13.8,4.3,-13.8,5.4).curveTo(-13.8,6.5,-13,7.1).curveTo(-12.3,7.7,-11.3,7.7).lineTo(-1,7.7).curveTo(0.2,7.7,0.8,7).curveTo(1.4,6.3,1.4,5.3).lineTo(1.4,-2.7).curveTo(1.4,-3.8,0.7,-4.5).curveTo(0.1,-5.2,-1,-5.2).lineTo(-13.5,-5.2).lineTo(-13.5,-10.6).lineTo(-1,-10.6).curveTo(0.1,-10.6,1.5,-10.2).curveTo(2.9,-9.7,4.1,-8.8).curveTo(5.3,-7.9,6,-6.4).curveTo(6.9,-4.9,6.8,-2.7).lineTo(6.8,5.3).curveTo(6.8,6.5,6.5,7.9).curveTo(6,9.2,5.1,10.4).curveTo(4.2,11.6,2.7,12.4).curveTo(1.1,13.2,-1,13.2).closePath().moveTo(-27.2,13.2).curveTo(-28.4,13.2,-29.8,12.8).curveTo(-31.2,12.3,-32.4,11.4).curveTo(-33.6,10.4,-34.4,8.9).curveTo(-35.2,7.4,-35.2,5.2).lineTo(-35.2,-5.2).lineTo(-37.9,-5.2).lineTo(-37.9,-10.6).lineTo(-35.2,-10.6).lineTo(-35.2,-20.6).lineTo(-29.5,-20.6).lineTo(-29.5,-10.6).lineTo(-17.5,-10.6).lineTo(-17.5,-5.2).lineTo(-29.5,-5.2).lineTo(-29.5,5.2).curveTo(-29.5,6.2,-28.8,6.8).curveTo(-28.2,7.5,-27.2,7.5).lineTo(-24.7,7.5).lineTo(-24.7,13.2).closePath();
	this.shape_1.setTransform(147.4235,40.0098,0.7275,0.7273);

	this.instance = new lib.CachedBmp_1();
	this.instance.setTransform(69.8,13.2,0.5,0.5);

	this.instance_1 = new lib.Image();
	this.instance_1.setTransform(0,0,0.1182,0.1181);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1,p:{scaleX:0.7275,scaleY:0.7273,x:147.4235,y:40.0098}},{t:this.shape,p:{scaleX:0.7275,scaleY:0.7273,x:97.1163,y:37.3007}}]},2).to({state:[{t:this.shape_1,p:{scaleX:0.9698,scaleY:0.9697,x:154.8939,y:39.9801}},{t:this.shape,p:{scaleX:0.9698,scaleY:0.9697,x:87.832,y:36.368}}]},1).to({state:[{t:this.instance_1},{t:this.instance}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,191.7,60);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 278;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.go_back = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.instance = new lib.button();
	this.instance.setTransform(20.25,40.25,0.3126,0.6252,0,0,0,0.8,0.4);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text
	this.instance_1 = new lib.CachedBmp_13();
	this.instance_1.setTransform(8.5,21.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,40).lineTo(-20,-40).lineTo(20,-40).lineTo(20,40).closePath();
	this.shape.setTransform(20,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.go_back, new cjs.Rectangle(0,0,40,80), null);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1408.05,13);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1312.85,13);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(1082.25,13);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(926.85,13);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(778.15,13);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(620.65,13);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(1198.15,13);

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(410.85,13);

	this.instance_8 = new lib.vertical();
	this.instance_8.setTransform(240.25,13);

	this.instance_9 = new lib.vertical();
	this.instance_9.setTransform(73.85,13);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_10 = new lib.square();
	this.instance_10.setTransform(4,4);
	this.instance_10.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// ball
	this.instance_11 = new lib.ball();
	this.instance_11.setTransform(4,4);
	this.instance_11.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	// title
	this.instance_12 = new lib.CachedBmp_12();
	this.instance_12.setTransform(1424.95,0,0.5,0.5);

	this.instance_13 = new lib.CachedBmp_11();
	this.instance_13.setTransform(427.6,0,0.5,0.5);

	this.instance_14 = new lib.CachedBmp_10();
	this.instance_14.setTransform(1099.15,0,0.5,0.5);

	this.instance_15 = new lib.CachedBmp_9();
	this.instance_15.setTransform(90.7,0,0.5,0.5);

	this.instance_16 = new lib.CachedBmp_8();
	this.instance_16.setTransform(1329.7,0,0.5,0.5);

	this.instance_17 = new lib.CachedBmp_7();
	this.instance_17.setTransform(1215,0,0.5,0.5);

	this.instance_18 = new lib.CachedBmp_6();
	this.instance_18.setTransform(257.1,0,0.5,0.5);

	this.instance_19 = new lib.CachedBmp_5();
	this.instance_19.setTransform(943.75,0,0.5,0.5);

	this.instance_20 = new lib.CachedBmp_4();
	this.instance_20.setTransform(794.95,0,0.5,0.5);

	this.instance_21 = new lib.CachedBmp_3();
	this.instance_21.setTransform(637.55,0,0.5,0.5);

	this.instance_22 = new lib.CachedBmp_2();
	this.instance_22.setTransform(-0.05,0,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1483,26), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:0},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.setTransform(0,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// image_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	mask.setTransform(960,40);

	// image
	this.instance_1 = new lib.shadow();
	this.instance_1.setTransform(960,-460,1,1,0,0,0,960,540);
	this.instance_1.compositeOperation = "multiply";

	var maskedShapeInstanceList = [this.instance_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#071E3A").beginStroke().moveTo(-960,40).lineTo(-960,-40).lineTo(960,-40).lineTo(960,40).closePath();
	this.shape.setTransform(960,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-1,0,1922,80), null);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#071E3A").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape.setTransform(960,540);
	this.shape._off = true;

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_1.setTransform(960,540);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#EDDEC5").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_2.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).wait(1));
	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2).to({_off:false},0).wait(1).to({_off:true},1).wait(2).to({_off:false},0).wait(1).to({_off:true},1).wait(3).to({_off:false},0).wait(1));

	// size
	this.instance = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:147.65},0).wait(1).to({x:290.2},0).wait(1).to({x:468.05},0).wait(1).to({x:644.85},0).wait(1).to({x:812.8},0).wait(1).to({x:988.35},0).wait(1).to({x:1158.1},0).wait(1).to({x:1299.9},0).wait(1).to({x:1454.6},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1477.2,90);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		const gotoPage = (event, {url}) => {
		    /**
		     * Go back page for portal.
		     */
		    window.open(url, '_self');
		}
		
		this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage, false, false, {url: 'https://dialogo.interativo.app.br'});
		
		// const gotoPage = () => {
		//     /**
		//      * Close page with extension plugin chrome.
		//      */
		// 	//chrome.runtime.sendMessage('maglcmgfenlbeehaeohfbkncflcafmko', {action: 'closeBrowser'});
		//     /**
		//      * Close page with window browser.
		//      */
		// 	window.close();
		// }
		//
		// this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		// this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// go_back
	this.btn_go_back = new lib.go_back();
	this.btn_go_back.name = "btn_go_back";
	this.btn_go_back.setTransform(1879.9,1000);

	this.timeline.addTween(cjs.Tween.get(this.btn_go_back).wait(1));

	// button
	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1775.3,1040.05,0.4515,0.4688,0,0,0,0.6,0.1);
	this.btn_page12.visible = false;
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1681.85,1040.05,0.4788,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1576.95,1040.05,0.6311,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1461.75,1040.05,0.6405,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1326.15,1040.05,0.9491,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1174.1,1040.05,0.8968,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(1020.85,1040.05,0.9655,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(837.45,1040.05,1.3741,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(646.9,1040.05,1.0679,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(478.4,1040.05,1.0351,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(349.7,1040.05,0.4445,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(185.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(350,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(349.6,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1095.4,1009);
	this.instance.visible = false;

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1730.1,1009,1.1053,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_2 = new lib.title();
	this.instance_2.setTransform(321.15,1027);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// logo
	this.occ_logo = new lib.logo();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(76,1010.05);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_3 = new lib.background();
	this.instance_3.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-1,0,1922,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// Model
	this.instance = new lib.zoom_brack();
	this.instance.setTransform(16.8,-40.9,1,1,0,0,0,0.3,0.3);

	this.instance_1 = new lib.zoom_white();
	this.instance_1.setTransform(102.35,-40.9,1,1,0,0,0,0.3,0.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[]},1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02}]},1).wait(1));

	// stageBackground
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("rgba(0,0,0,0)").setStrokeStyle(1,1,1,3,true).moveTo(-970,-550).lineTo(970,-550).lineTo(970,550).lineTo(-970,550).closePath();
	this.shape.setTransform(960,540);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-970,550).lineTo(-970,-550).lineTo(970,-550).lineTo(970,550).closePath();
	this.shape_1.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(3));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(949,480.6,982,689.4);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/index_atlas_1.png", id:"index_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
 